module.exports = __webpack_public_path__ + "img/thumbnail_RedFox_m_erythristic.ddf0efec.png";